const OffsetToTime = {
  3600:	'1 hour',
  7200:	'2 hours',
  10800: '3 hours',
  14400: '4 hours',
  18000: '5 hours',
  21600: '6 hours',
  25200: '7 hours',
  86400: '1 day',
  172800:	'2 days',
  259200:	'3 days',
  345600:	'4 days',
  432000:	'5 days',
  518400:	'6 days',
  604800:	'7 days',
  691200:	'8 days',
  777600:	'9 days',
  864000:	'10 days',
  950400:	'11 days',
  1036800: '12 days',
  1123200: '13 days',
  1209600: '14 days',
  1296000: '15 days',
  1382400: '16 days',
  1468800: '17 days',
  1555200: '18 days',
  1641600: '19 days',
  1728000: '20 days',
  1814400: '21 days',
  1900800: '22 days',
  1987200: '23 days',
  2073600: '24 days',
  2160000: '25 days',
  2246400: '26 days',
  2332800: '27 days',
  2419200: '28 days',
  2505600: '29 days',
  2592000: '30 days',
}

export default OffsetToTime



// WEBPACK FOOTER //
// ./src/components/sitewide/OffsetToTime.js